import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {TokenStorageService} from '../service/auth/token-storage.service';

export const AuthorizationHeader = 'Authorization';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private token: TokenStorageService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const token = this.token.getToken();
    let headers = {};

    if (token != null) {
      headers = {
        setHeaders: {
          // 'X-API-KEY': `${environment.xApiKey}`,
          // 'X-API-SECRET': `${environment.xApiSecret}`,
          'Authorization': `Bearer ${token}`
        }
      }
    }

    const authReq = req.clone(headers);

      return next.handle(authReq);
  }
}
